module.exports = __webpack_public_path__ + "static/media/tailwindcss-icon.760a3ee4.svg";